/* eslint-disable no-nested-ternary */
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  regionalCoach: ({ hideBox }) => ({
    background: theme.palette.blue.light100,
    display: 'flex',
    position: 'relative',
    width: '100%',
    flexDirection: hideBox && 'column',
    [theme.breakpoints.up('md')]: {
      height: '40rem',
    },
  }),
  maxWidthContainer: ({ flipped }) => ({
    width: '100%',
    height: '100%',
    margin: '0 auto',
    background: theme.palette.blue.light100,
    [theme.breakpoints.up('md')]: {
      paddingLeft: !flipped && '45%',
      paddingRight: flipped && '55%',
    },
  }),
  introContainer: ({ flipped, hideBox }) => ({
    height: '100%',
    position: 'relative',
    marginBottom: hideBox ? 0 : 60,
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'center',
    padding: '50px 34px 50px',
    background: theme.palette.blue.light100,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 42,
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      padding: flipped ? '32px 132px 32px 62px' : hideBox ? '32px 72px 32px 110px' : '32px 72px 32px 182px',
    },
    [theme.breakpoints.up(1200)]: {
      padding: flipped && '32px 182px 32px 62px',
    },
    [theme.breakpoints.up(2200)]: {
      minWidth: '500px',
    },
    [theme.breakpoints.up(2400)]: {
      paddingLeft: flipped && '50%',
    },
  }),
  heading: ({ hideBox }) => ({
    ...theme.typography.h2,
    color: theme.palette.secondary.light,
    marginBottom: 20,
    marginTop: hideBox ? 0 : 42,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  }),
  supportiveCopy: {
    maxWidth: '732px',
    marginBottom: 0,
    ...theme.typography.body1,
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  ctaContainer: {
    marginTop: 40,
    [theme.breakpoints.up('md')]: {
      marginBottom: 40,
    },
  },
  splitContainer: ({ flipped, hideBox }) => ({
    width: '100%',
    position: hideBox ? 'relative' : 'absolute',
    top: 0,
    left: !flipped && 0,
    right: flipped && 0,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      position: 'absolute',
      top: 0,
      left: !flipped && 0,
      right: flipped && 0,
      width: '100%',
      height: '100%',
      backgroundColor: theme.palette.background.paper,
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      zIndex: 0,
      flexDirection: 'row',
    },
  }),
  imagerySection: {
    height: 485,
    [theme.breakpoints.up('sm')]: {
      height: 398,
    },
    [theme.breakpoints.up('md')]: {
      height: 'unset',
      flexBasis: '60%',
    },
  },
  imagerySectionImg: ({ flipped }) => ({
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    position: flipped && 'absolute',
    right: flipped && 0,
  }),
  floatingBox: ({ flipped }) => ({
    background: 'white',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    padding: '24px 24px 12px',
    borderRadius: 8,
    [theme.breakpoints.up('sm')]: {
      padding: 36,
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 'unset',
      position: 'absolute',
      top: '50%',
      marginTop: -230,
      padding: '52px 54px 50px',
      left: !flipped && -450,
      right: flipped && -480,
      width: 544,
    },
    [theme.breakpoints.up(1200)]: {
      position: 'absolute',
      top: '50%',
      height: 460,
      marginTop: -230,
      padding: '52px 54px 50px',
      left: !flipped && -520,
      right: flipped && -520,
      width: 600,
    },
    [theme.breakpoints.up(1300)]: {
      left: !flipped && -580,
      right: flipped && -580,
      width: 700,
    },
    [theme.breakpoints.up(1560)]: {
      left: !flipped && -732,
      right: flipped && -732,
      width: 844,
    },
  }),
  floatingBoxFlexContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
    [theme.breakpoints.up(1200)]: {
      flexDirection: 'row',
    },
  },
  floatingBoxImg: {
    height: 351,
    [theme.breakpoints.up('sm')]: {
      width: 'unset',
      flexBasis: '50%',
    },
    [theme.breakpoints.up('md')]: {
      width: 364,
      height: 351,
    },
    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },
  floatingBoxCopyContainer: {
    textAlign: 'center',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginTop: 24,
    [theme.breakpoints.up('sm')]: {
      marginLeft: 20,
      position: 'relative',
      flexBasis: '50%',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: -12,
      marginLeft: 40,
      flexGrow: 0,
    },
  },
  floatingBoxHeading: {
    ...theme.typography.h4,
    color: theme.palette.secondary.light,
    margin: '0 0 15px 0',
  },
  floatingBoxSupportiveCopy: {
    ...theme.typography.body1,
  },
  floatingBoxButtonContainer: {
    marginTop: 20,
    paddingTop: 12,
    borderTop: '1px solid #D8D8D8',
    [theme.breakpoints.up('sm')]: {
      position: 'absolute',
      width: '100%',
      bottom: -12,
    },
  },
  button: {
    lineHeight: 1,
  },
  backgroundOverlay: ({ backgroundColor }) => ({
    backgroundColor,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  }),
}))

export default useStyles
